import styled from "styled-components";
import { COLORS, responsive } from "../../../../styles/constants.style";

export const ClientSearchFormWrapper = styled.div`
  background-color: ${COLORS.cirrus_white};
  .form-header {
    padding-left: 16px;

    ${responsive.MOBILE`
      padding-left: 8px;
    `}
    .form-header-left {
      line-height: 20px;
      color: ${COLORS.cirrus_black10};
    }

    ${responsive.MOBILE`
        justify-content: space-between;
        align-items: center;
      `};
  }

  .form-header-right {
    display: flex;
    justify-content: flex-end;
    align-items: center;

    .MuiButton-root {
      height: auto;
      padding-left: 4px;

      svg {
        margin-right: 10px;
      }
    }
  }
  .form-container {
    padding: 0px 0px 16px 16px;

    ${responsive.MOBILE`
      padding: 0px 8px 16px 8px;
    `}
  }

  .responsive-search-btn-container {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 16px;
  }

  .button-container {
    justify-content: end;
    padding-bottom: 20px;
    gap: 16px;
    margin-right: 16px;
    margin-top: 40px;
    ${responsive.MOBILE`
      flex-direction:column-reverse;
      padding: 16px 8px 16px 8px !important;
      padding-bottom: 0px !important;
      margin-top: 0px !important;
      margin-right: 0px !important;
      padding-bottom: 16px !important;
    `}
  }
  .padding-horizontal {
    ${responsive.MOBILE`
      margin: 0px 8px;
    `}
  }
  .MuiGrid2-root {
    padding-right: 16px;

    ${responsive.MOBILE`
       padding-right: 8px;
    `}
  }
  .MuiGrid2-container {
    padding-right: 0px;
  }

  .confirm-message {
    line-height: 20px;
    margin-bottom: 8px;
    color: ${COLORS.cirrus_black10};
  }

  .item-name {
    line-height: 20px;
    color: ${COLORS.cirrus_black10};
  }
  .reset-all-button {
    margin-right: 16px;
  }
`;
